<template>
  <ranking-page
    endpoint="/spontan/ranking/total/counts/year"
    heading-danish="Rangliste - Spontantællinger i år"
    heading-english="Ranking - Total spontaneous current year"
  />
</template>

<script>
import RankingPage from "./RankingPage.vue";

export default {
  components: { RankingPage },
};
</script>
